
// Global variables
var $checkoutObj = {};

$checkoutObj.cartServiceUrl = function() {
	var cartAPIURL = '/wcs/resources/store/'+WCParamJS.storeId+'/cart/@self?v=' +new Date().getTime();
	return cartAPIURL;
};

$checkoutObj.setCallParams = function(callType) {
    var callParams = {
        responseFormat: 'json'
    }

    $checkoutObj.callParams = callParams;
    return $checkoutObj.callParams;
}

$checkoutObj.getCartData = function(callback) {
    $checkoutObj.setCallParams("cart");
    $.ajax({
        url: $checkoutObj.cartServiceUrl(),
        type: 'GET',
        //data: $.param($checkoutObj.callParams,true),
        success: function(data) {
            $checkoutObj.resultCount = data.recordSetTotal;
        	if (data.recordSetCount > 0) {
                $checkoutObj.cartData = data;
                callback();
            } else {
                renderEmptyCart();
            }
        },
        error: function(error) {
            renderEmptyCart();
            return error;
        },
        complete: function (data) {
            setTimeout(removeCheckoutLoader, 250);
            return;
        }
    });
};

/**
 * @funtion removeCheckoutLoader
 * @desc This function removes the Loader
 */
 function removeCheckoutLoader(){
    if ($( "#loadingDiv" ).length > 0) {
        $( "#loadingDiv" ).fadeOut(250, function() {
            // fadeOut complete. Remove the loading div
            $( "#loadingDiv" ).remove(); //makes page more lightweight 
        });  
    }
}

/**
 * @funtion addCheckoutLoader
 * @desc This function adds the Loader
 */
 function addCheckoutLoader(ajaxURL, showLoader = true) {
     if(showLoader) {
        if ($('#loadingDiv').length == 0) {
            $('body').prepend('<div style="" id="loadingDiv"><div class="checkout-loader">Loading...</div></div>');
        }
     }

    if (typeof ajaxURL != 'undefined') {
        $.ajax({
            method: "GET",
            url: ajaxURL,
            success: function(data, textStatus, jqXHR){
                window.location.href = ajaxURL;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error(errorThrown);
                removeCheckoutLoader();
            }
        });
    } else {
        $(window).on('load', function(){
            setTimeout(removeCheckoutLoader, 250); //wait for page load PLUS 250ms.
        });
    }
 }



function closeOverlay() {
    $(".perks_overlay-container").hide();
}

var loaderInButtonShowed = false;

function showLoaderInButton(buttonId,moveLeft = false) {
    if (!loaderInButtonShowed) {
        var ERROR_ELEMENT_NOT_FOUND = "showLoaderInButton()::loaderButton element not found";
        var button;
        var loaderImg;
        if(buttonId == 'goReturnView' || buttonId == 'goCostumerService' || buttonId == 'createAccount'){
        	loaderImg = "https://assets.persol.com/extra/image/Persol/loader-202125.gif";
        }else{
        	loaderImg = "https://assets.persol.com/extra/image/Persol/icons/ajax-loader_white.gif";
        }
 

        button = document.getElementById(buttonId);
        if (!button){
            console.log(ERROR_ELEMENT_NOT_FOUND);
        }
        else {
            var divElement = document.createElement('img');
            divElement.setAttribute('src',loaderImg);
            divElement.setAttribute('alt','loaderImg');
            divElement.setAttribute('class','loader');
            divElement.setAttribute('id','loaderInButton')
            if(moveLeft)
                divElement.setAttribute('style','margin-left:-2.5rem');
            button.prepend(divElement);
            
            //If for any reason a button is not restored it will be automatically unlocked after 10sec
            setTimeout(function(){
                removeLoaderInButton(button);
            }, 10000);
            loaderInButtonShowed = true;
            
        }
    }
}

function removeLoaderInButton(button) {
    var loaderImgElem = button.getElementsByClassName('loader');
    if(loaderImgElem.length > 0) {
        loaderImgElem[0].remove();
    }
    loaderInButtonShowed = false;
}

function initVariables() {
    if (itemsInCartBadge != '0' && (window.mobilecheck() || window.tabletPortraitCheck())) {
        $('.top-checkout-button').show();
        // item attributes popup button for mobile
        $('.viewItemDetails').show();
    } else {
        // item attributes div for Desktop
        $('.itemAttributes').show();
    }
}

function postOperations() {
    if (WCParamJS.countryCode.toUpperCase() == 'US' || WCParamJS.countryCode.toUpperCase() == 'CA') {
        $("#wcs-estemated-tax-box-close").click(function() {
            CheckoutHelperJS.showHideEstematedTaxDialog(false);
        });

        $(window).keydown(function(event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });
    }

    var isCalculateTaxesPopup = $('#wcs-calculate-tax').length > 0;
    if(isCalculateTaxesPopup) {
        clickOnElementWithEnter();
        setFocusOnTab();
    }

    $(".close-viewdetails, .fade-viewdetails").click(function(event) {
        event.stopPropagation();
        $(".cartitem").removeClass('showed-details');
        $(".fade-viewdetails").hide();
        // iOS body scroll lock
        bodyScrollLock.enableBodyScroll(document.querySelector('#contentWrapper'));
        $("body").css("position", "");

        if(isPersol){
            $("html").removeClass("overflow-hidden");
        } else {
            $("body").removeClass("overflow-hidden");
        }
        $('#contentWrapper').removeClass("overflow-hidden");
    
        var windowSize = window.innerWidth;
        if (windowSize <= 1024) {
            $("html").css("overflow-y", "initial");
        }
    });

    // user has added or removed a promocode, we have to reload promotion form
    if ($checkoutObj.promotionReloading) {
        promotionFormConstructor();
    }

    // hide carousel X-SELL if there are no products
    if($('.checkout-carousel-conteiner .espot-cart-alsolike .carousel').length == 0){
        $('.checkout-carousel-conteiner').hide();
    }
    
}

function promotionFormConstructor() {
    var enterPromotionString = $('#enterPromotionString').val() != null ? $('#enterPromotionString').val() : '';
    var applyString = $('#applyString').val() != null ? $('#applyString').val() : '';
    var checkoutPromoCodeApplyString = $('#checkoutPromoCodeApplyString').val() != null ? $('#checkoutPromoCodeApplyString').val() : '';
    var removePromotionString = $('#removePromotionString').val() != null ? $('#removePromotionString').val() : '';
    var shopOnBehalfSessionEstablished = $('#shopOnBehalfSessionEstablished').val() != null ? $('#shopOnBehalfSessionEstablished').val() : '';
    var currentOrderID = $('#currentOrderId').val();
    var promotionFormHtml = '';
    var promotionQuestion = $('#promotionQuestion').val();
    var promoSuccessMsg =  $('#promoCodeAppliedMsg').val();

    if ($checkoutObj.cartData.promotionCode != null && $checkoutObj.cartData.promotionCode.length > 0) {
        // promotion form used when 1 or more promotion codes are applied
        promotionFormHtml = '<div id="appliedPromotionCodes" class="promotion-code">';
        for (var promoIndex in $checkoutObj.cartData.promotionCode) {
            var promoCode = $checkoutObj.cartData.promotionCode[promoIndex].code;
            if (!promoCode.startsWith('IDME')) {
                var cleanedPromoCode = promoCode.replaceAll("\'", "&#39;");
                promotionFormHtml += '<div class="promotion-code__used">';
                if ($checkoutObj.cartData.locked != 'true' || shopOnBehalfSessionEstablished == 'true') {
                   // promotionFormHtml += '<div class="promotion-code__success">'+promoCode+'</div>';
                    promotionFormHtml += '<div class="promotion-success">';
                    promotionFormHtml += '    <div class="input-style" id="WC_PromotionCodeDisplay_div_2">';
                    promotionFormHtml += '        <input required disabled type="text" size="25" name="promoCode" tabindex="-1"';
                    promotionFormHtml += '           id="promoCode" value="'+promoCode+'"'; 
                    promotionFormHtml += '           onkeypress="if(event.keyCode==13) JavaScript:CheckoutHelperJS.applyPromotionCode(\'PromotionCodeForm\',\''+currentOrderID+'\')"';
                    promotionFormHtml += '        />';
                    promotionFormHtml += '        <label for="promoCode" class="">'+ +'</label>';
                    promotionFormHtml += '    </div>';
                    promotionFormHtml += '   </div>';
                    promotionFormHtml += '<div class="success-message" ><span>'+promoSuccessMsg+'</span> </div>'
                    promotionFormHtml += '<div class="button removebutton" data-element-id="X_X_PromoCode_Remove">';
                    promotionFormHtml += '<a class="font1" id="promotion_'+promoIndex+'" href="#" ';
                    promotionFormHtml += '  onclick=\'JavaScript:setCurrentId("promotion_'+promoIndex+'");';
                    promotionFormHtml += '  CheckoutHelperJS.removePromotionCode("'+cleanedPromoCode+'","'+currentOrderID+'");return false;\'>';
                    promotionFormHtml += removePromotionString + '</a></div>';
                } else {
                    promotionFormHtml += '<div class="promotion-code__success">'+promoCode+'</div>';
                }
                promotionFormHtml += '</div>';
            }
        }
        promotionFormHtml += '</div>';
    } else {
        // promotion form used when no promotion codes are applied 
        idMeRemoved = $('#promotion-code__input').length == 0; //the label is not present when the id me promise is removed
        if(isPersol && idMeRemoved){ 
            promotionFormHtml = '<input type="checkbox" class="promotion-code__input" id="promotion-code__input" />';
	        promotionFormHtml +='<label for="promotion-code__input" class="promotion-code__label" tabindex="0">';
			promotionFormHtml += promotionQuestion;
	        promotionFormHtml +='<span class="arrow arrow-down"></span>';
	        promotionFormHtml +='</label>';
            $('#PromotionCodeForm').before(promotionFormHtml);
        }
        promotionFormHtml = '<div class="">';
        promotionFormHtml += '    <div class="input-style" id="WC_PromotionCodeDisplay_div_2">';
        promotionFormHtml += '        <input required type="text" size="25" name="promoCode" tabindex="-1"';
        promotionFormHtml += '           id="promoCode" '; 
        promotionFormHtml += '           onkeypress="if(event.keyCode==13) JavaScript:CheckoutHelperJS.applyPromotionCode(\'PromotionCodeForm\',\''+currentOrderID+'\')"';
        promotionFormHtml += '        />';
        promotionFormHtml += '        <label for="promoCode" class="">'+ +'</label>';
        promotionFormHtml += '    </div>';

        promotionFormHtml += '<div class="promocode-button-wrapper">';
        promotionFormHtml += '      <button class="button_primary button graydark-gray" id="WC_PromotionCodeDisplay_links_1" data-element-id="X_X_PromoCode_Apply" tabindex="-1" onclick="';
        promotionFormHtml += '                JavaScript:setCurrentId(\'WC_PromotionCodeDisplay_links_1\');';
        promotionFormHtml += '                   CheckoutHelperJS.applyPromotionCode(\'PromotionCodeForm\',\''+currentOrderID+'\');';
        promotionFormHtml += '                   setTimeout(function() { trackPromotionCode(); }, 1000);';
        promotionFormHtml += '                   return false;">'+applyString;
        promotionFormHtml += '           <div class="button_text"><span id="WC_PromotionCodeDisplay_links_1_ACCE_Label" class="spanacce">'+checkoutPromoCodeApplyString+'</span></div>';
        promotionFormHtml += '      </button></div></div>';
        if(isPersol){ //idme only for perssol 
            promotionFormHtmlIdMe =    '<div class="idme-button">'
            promotionFormHtmlIdMe +='<a href="javascript:void(0)" alt="ID.me Link" data-element-id="X_CartPage_PromoCode_IDme">'
            promotionFormHtmlIdMe +=   '<img src="https://s3.amazonaws.com/idme/buttons/v4/verify-with-idme.png" style="width:auto" onclick="IDmePopUp()" alt="ID.me Button"/>'
            promotionFormHtmlIdMe +='</a>'
            promotionFormHtmlIdMe +='</div>'
            promotionFormHtmlIdMe +='<div class="idme-description">Verification by ID.me</div>'
            $('#idme-section-slide').empty();
            $('#idme-section-slide').append(promotionFormHtmlIdMe);

        }
    }

    if ($('#PromotionCodeForm_upper').length > 0) {
        $('#PromotionCodeForm_upper').empty();
        $('#PromotionCodeForm_upper').append(promotionFormHtml);
    }
}

function viewDetailsClicked(orderItemID) {
    if($("#cartitem_"+orderItemID).hasClass("opened"))
    {
        $("#cartitem_"+orderItemID).removeClass("opened");
    }else
    {
        $("#cartitem_"+orderItemID).addClass("opened");
        
    }
    
   /* if (($('#close-viewdetails').attr('href') == undefined)){
        $('#close-viewdetails').attr('href','#');
    }
    var windowSize = window.innerWidth;
    $(".fade-viewdetails").show();

    if(isPersol){ 
        $("html").addClass("overflow-hidden");    	 
    } else{
        $("body").addClass("overflow-hidden");
        $("body").css("position", "relative");
    }
    $("#contentWrapper").addClass("overflow-hidden");*/
    
    //startPopup(orderItemID);
}

function startPopup(orderItemID) {
    $("#cartitem_"+orderItemID).addClass('showed-details');
    $(".fade-viewdetails").show();
    // iOS body scroll lock
    bodyScrollLock.disableBodyScroll(document.querySelector('#contentWrapper'));

    $('#owl-pdp').owlCarousel({
        singleItem: true,
        addClassActive: true,
        navigation:true,
        loop: true,
        mouseDrag : true,
        touchDrag : true,
        slideSpeed: 600,
        lazyLoad: true,
        paginationNumbers:true,
        afterInit: initAccessibility,
        afterAction: manageAccessibility,
        navigationText: [
            "<button class='btn--owl-nav btn--owl-prev' aria-label='previous item'></button>",
            "<button class='btn--owl-nav btn--owl-next' aria-label='next item'></button>"
        ] 
    });

    $(".details--body").bind('scroll', function () {
        if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
            $('.cartitem--content__fade').hide();
        } else $('.cartitem--content__fade').show();
    });
}

function renderEmptyCart() {
    var hfreSun = '';
    var hrefOptical = '';
    $("#promotions").hide();
    $('.content_wrapper_position').addClass('empty_content_wrapper_position');
    $("#WC_CheckoutLogonf_div_3b").hide();
    $('#checkout-order-summary').scheletrone("stopLoader");
}

function ajaxCallCart(promotionReloading) {
    var page = $('#pageInfo').val();

    if (promotionReloading != undefined) {
        $checkoutObj.promotionReloading = promotionReloading;
    }
    
    $checkoutObj.getCartData(function() {

        if(page == 'Cart'){
            renderOrderSummary();
            postOperations();
            cursor_clear(); 
        }else if(page == 'Shipping'){
            //call cartservice fot total
            renderOrderSummary();
    
        }else if(page == 'returnDetails'){
            renderOrderSummary();
            // Executed as last operation
        }
        else if(page == 'createReturn'){
            //call cartservice fot total
            renderOrderSummary();
        }
    });
};

function initAccessibility(){
    //accessibility screen reader
    $('#owl-pdp .owl-item').attr('aria-selected','false');
    $('#owl-pdp .owl-item.active').attr('aria-selected','true'); 
}

function manageAccessibility(){
    // apply meta info to next and previous buttons and make them focusable
   //  $('#owl-pdp').attr('role', 'carousel');
    $('#owl-pdp .owl-item.active .popup_link').attr('tabindex','0');
    $('#owl-pdp .owl-item').attr('aria-selected','false');
    $('#owl-pdp .owl-item.active').attr('aria-selected','true');
    $('#owl-pdp .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
    $('#owl-pdp .owl-pagination .owl-page.active') .attr('title','Active Slide')
    $('#owl-pdp .owl-pagination .owl-page').on('keydown', function(e){
        if(e.keyCode == 13){
            var slideToGO = parseFloat($(this).children('.owl-numbers').html());
            $("#owl-pdp").data('owlCarousel').goTo(slideToGO - 1);
            $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).focus().attr('title','Active Slide')
            $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
            $($('#owl-pdp .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
        }
        
    })

    $('#owl-pdp .owl-item').attr('aria-selected','false');
    $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}

/*function getProductImage(parnumber,type){
   var  retunedType = '__002';
    if(localStorage['manifestMap'] != undefined && localStorage['manifestMap'] != null  ){
        
        try {
            var manifestMap = $.parseJSON(localStorage['manifestMap']);
        } catch(e) {
            return retunedType
        }
        
        $.each(manifestMap, function(partnumberMap, typesImg) {
            if(partnumberMap == parnumber){
                if(typesImg.includes(type)){
                    retunedType = '_'+type.toString();
                    return false;   
                }else{
                    if(type == '_STD__shad__qt'){
                        retunedType = '__002';
                        return false;
                    }else{
                        retunedType = '__002'
                        return false;
                    }
                }
            }
            

        });
    }
    return retunedType;
}*/

function replaceImageCheckout(imges){
    $.each(imges, function(index,img){
        
    if(img.childNodes.length>0){ //if is picture
        var picture = img;
        for(var j = 0; j < picture.childNodes.length; j++){
            if( picture.childNodes[j].nodeName == "IMG"){
                var urlImg=  picture.childNodes[j].dataset['img'];
                //urlImg = urlImg.replace('__001',getProductImage(picture.childNodes[j].dataset['partnumber'].replace('RX_',''),'_STD__shad__qt'));
                picture.childNodes[j].dataset['srcset'] = urlImg
            }  
        }
        for(var g = 0; g < picture.childNodes.length; g++){
            if( picture.childNodes[g].nodeName == "SOURCE"){
                picture.childNodes[g].setAttribute('srcset', urlImg);
               // picture.childNodes[g].dataset['srcset'] = urlImg
            }
        }


    }else{
        var urlImg= img.dataset['img'];
       //urlImg = urlImg.replace('__001',getProductImage(img.dataset['partnumber'].replace('RX_',''),'_STD__shad__qt'));
       img.dataset['src'] = urlImg;
       img.src = urlImg;
    }
       
       
    });

}

function renderOrderSummary() {

    var page = $('#pageInfo').val();
    var templateOrderSummaryHtml = $('#checkoutSummaryTemplate').html();
    if(page == 'Cart' || page == 'Shipping' | page == 'returnDetails' | page == 'createReturn'){
        var cartData = $checkoutObj.cartData;
    } else if (page == 'createReturn' || page == 'returnThankYou'){
        var cartData;
    } else{
        var cartData = orderInfoAfterPayment;
    }
  

    if(cartData != undefined && cartData.adjustment != ''){
            //Check for product discount or total order discount
            var productDiscount = false;
            var orderDiscount = false;
            var productDiscountAmount = 0;
            var orderDiscountAmount = 0;
            var productDiscounts = [];
            if (cartData.adjustment != undefined && cartData.adjustment != '') {
                for (var adjIndex in cartData.adjustment) {
                    var adjustment = cartData.adjustment[adjIndex]
                    if (adjustment.displayLevel == "OrderItem") {
                        productDiscount = true;
                        productDiscounts.push(adjustment.amount);
                        productDiscountAmount += parseFloat(adjustment.amount);
                    } else if (adjustment.displayLevel == "Order" && (adjustment.usage == 'Discount' || adjustment.xadju_calUsageId == -1)) {
                        orderDiscount = true;
                        orderDiscountAmount += parseFloat(adjustment.amount);
                    }
                }
            }

            var mustacheObj = {
                hasOrderItems: function() {
                    return (cartData.orderItem != undefined && cartData.orderItem.length > 0) ? true : false;
                },
                totalProductPrice: cartData.totalProductPrice,
                totalProductPriceString: function() {
                    return this.totalProductPrice != '' ?  WCCurrencyJS.format(this.totalProductPrice) : '';
                },
                totalDiscountProductsString: function() {
                    return this.totalProductDiscount != '' ?  WCCurrencyJS.format(Math.abs(this.totalProductDiscount)) : '';
                },
                totalSalesTax: cartData.totalSalesTax,
                noSalesTax: false,
                hasTotalSalesTax: function() {
                    if (this.totalSalesTax != '' && this.totalSalesTax > 0) {
                        return true;
                    } else {
                        this.noSalesTax = true;
                        return false;
                    }
                },
                totalSalesTaxString: function() {
                    return this.totalSalesTax != '' ? WCCurrencyJS.format(this.totalSalesTax) : '';
                },
                orderId: cartData.orderId,
                listProductDiscounts: productDiscounts,
                totalProductDiscount: productDiscountAmount,
                totalOrderDiscount: orderDiscountAmount,
                hasOrderDiscount: function() {
                    return Math.abs(this.totalOrderDiscount) > 0 ? true : false; 
                },
                hasProductsDiscount: function() {
                    return Math.abs(this.totalProductDiscount) > 0 ? true : false; 
                },
                totalOrderDiscountString: function() {
                    return WCCurrencyJS.format(Math.abs(this.totalOrderDiscount));
                },
                hasCostShipping: false,
                hasFreeShipping: function() {
                    if (cartData.totalShippingCharge > 0) {
                        this.hasCostShipping = true;
                        return false;
                    } else return true;
                },
                typeOfShipping : function(){    
                    if($('input[name="singleShipmentShippingMode"]:checked').length > 0){
                        var shipModeCode = $('input[name="singleShipmentShippingMode"]:checked').attr('shipmodecode');
                        var typeShipping = $('input[name="singleShipmentShippingMode"]:checked').attr('typeShipping');
                        if(shipModeCode == 'Mail') shipModeCode = 'Standard';
                        if(shipModeCode == 'GreenShipping') shipModeCode = 'Green';
                        sessionStorage.setItem('shipmentMethod' ,shipModeCode);
                        sessionStorage.setItem('typeShipping' ,typeShipping.toLowerCase());
                        sessionStorage.setItem('greenShippingAvailable' ,$('#greenShippingIsAvailable').val());
                        return typeShipping.toLowerCase();
                    }else if(page=='Thankyou'){
                        return sessionStorage.typeShipping;
                    } else {
                        return '';
                    }
                    
                },
                totalShippingCharge: function() {
                    return cartData.totalShippingCharge != '' ?  WCCurrencyJS.format(cartData.totalShippingCharge) : ''; 
                },
                totalAmount: function() {
                    return parseFloat(this.totalProductPrice) + parseFloat(this.totalProductDiscount) + parseFloat(this.totalOrderDiscount);
                },
                totalAmountString: function() {
                    return this.totalAmount() != '' ?  WCCurrencyJS.format(this.totalAmount()) : '';
                },
                totalAmountWithTaxes: function() {
                    return parseFloat(this.totalAmount()) + parseFloat(cartData.totalSalesTax);
                },
                totalAmountWithTaxesString: function() {
                    return this.totalAmountWithTaxes() != '' ?  WCCurrencyJS.format(this.totalAmountWithTaxes()) : '';
                }, 
                affirmPriceFormatWithTaxes: function() {
                    return (this.totalAmountWithTaxes() * 100).toString().replace('.','').replace(',','');
                }, 
                prescriptionError: function(){
                    var numberPrescItem = $( "#totalNumberOfItemsPresc" ).val();
                    if(numberPrescItem > 1){
                        $(".bottom-checkout-button .button__checkout").addClass("disabled");
                        $("#paypal-shortcut-div .checkout_policy").addClass("disabled-disclaimer");
                        $(".paypal_button_container").hide();//paypal button
                        $(".klarna_button_container").hide();//klarna button
                        $(".apple-pay-button, checkout_or_seperator-applepay").hide();// apple pay button
                        $(".bottom-checkout-button .button").css("cursor","default");
                        $(".bottom-checkout-button .button__checkout").attr('disabled', 'disabled');
                        if(window.mobilecheck() || window.tabletPortraitCheck()){
                            $(".top-checkout-button .button_primary ").addClass("disabled");
                            $(".top-checkout-button .button_primary ").attr('disabled', 'disabled');
                        }
                        return true;
                    }else{
                        $('.bottom-checkout-button').show();
                        $(".choose_shipping_method").show()
                        return false;
                    }
                },
                grandTotal: cartData.grandTotal,
                langForKlarna: $checkoutObj.langForKlarna,
                countryCodeForKlarna: $checkoutObj.countryCodeForKlarna,
                orderDiscountProductsString: $checkoutObj.orderDiscountProductsString,
                affirmPage: $checkoutObj.affirmPage
            };

            if (page == 'createReturn' || page == 'returnDetails'){
                mustacheObj.totalReturnPrice = $("#returnShippingPrice").length > 0 ? $("#returnShippingPrice").val() : '';
                mustacheObj.totalReturnAmountString = mustacheObj.totalReturnPrice != '' ?  WCCurrencyJS.format(mustacheObj.totalReturnPrice) : '';
                mustacheObj.affirmPriceFormat = (mustacheObj.totalReturnPrice * 100).toString().replace('.','').replace(',','');
            }

            var html = Mustache.to_html(templateOrderSummaryHtml, mustacheObj);

            if(page == 'Cart'){
                $('#checkoutSummary').find('div.order-summary-section').remove();
                $('#checkoutSummary').find('div.delivery-date').remove();
                $('#checkoutSummary').find('#checkout-order-summary').remove();
                $('#checkoutSummary').find('#prescriptionError').remove();
                if (isPersol) {
                    $('#checkoutSummary').prepend(html);
                } else {
                    if (window.mobilecheck() || window.tabletPortraitCheck()){
                        $('#checkoutSummary').prepend(html);
                    } else {
                        if($('#checkout-order-summary').length > 0){
                            $('#checkout-order-summary').remove();
                        }
                        if($('#prescriptionError').length > 0){
                            $('#prescriptionError').remove();
                        }
                        $(html).insertAfter('#checkoutSummary .choose_shipping_method')
                    }
                }
            }else{
                $('#checkout-order-summary').remove();
                $('#rightColSummary').prepend(html);
                if (page == 'createReturn') $('#checkoutSummary').prepend(html);
            }
            if (affirmEnabled == 'true') {
                affirm.ui.refresh();
            } else if (klarnaEnabled == 'true') {
                window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
            }
    } else {
        if (page == 'createReturn' || page == 'returnThankYou'){
            if ($("#returnShippingPrice").val() != '' && $("#returnShippingPrice").val() > 0) {
                var mustacheObj = {};
                mustacheObj.totalReturnPrice = $("#returnShippingPrice").length > 0 ? $("#returnShippingPrice").val() : '';
                mustacheObj.totalReturnAmountString = mustacheObj.totalReturnPrice != '' ?  WCCurrencyJS.format(mustacheObj.totalReturnPrice) : '';
                mustacheObj.affirmPriceFormat = (mustacheObj.totalReturnPrice * 100).toString().replace('.','').replace(',','');

                var html = Mustache.to_html(templateOrderSummaryHtml, mustacheObj);
                $('#checkoutSummary').prepend(html);
            }
        }
    }
}


function goToPaymentStep(){
    printShippingBillingInformation();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    if ($('#loadingPaymentDiv').length == 0) {
        $('.paymentDetails').css('height','400px');
        $('.paymentDetails').css('opacity','unset');
        $('#loaderForview').css('height','150px');
        $('#loaderForview').append('<div style="" id="loadingPaymentDiv"><div class="checkout-loader">Loading...</div></div>');
    }
    
    $(".billing-address").show();
    $("#unregistered_form").parent('.panel').removeClass('activated');
    $(".have_an_account").hide();
    $(".shipping-step .accordion").css("pointer-events","none");
    $(".return-details-wrapper").removeClass('activated');
    $("#shippingInformation").addClass("activated");
    

    //payment
    $(".paymentDetails .accordion").css("pointer-events","auto");
    $(".paymentDetails .accordion").addClass('accordion-active');
    $("#loaderForview").addClass('activated');
}

function setUpAccordion(){
    //shipping part
    $( " .shipping-step .accordion" ).click(function() {
        if($( " .shipping-step .accordion" ).siblings(".panel").hasClass('activated')){
            $(" .shipping-step .accordion" ).siblings(".panel").removeClass('activated');
        }else{
            $(" .shipping-step  .accordion" ).siblings(".panel").addClass('activated');
        }
      });
   //payment part 
   $( " .paymentDetails .accordion" ).click(function() {
        if($( " .paymentDetails .accordion" ).siblings(".panel").hasClass('activated')){

            $(" .paymentDetails .accordion" ).siblings(".panel").removeClass('activated');
        }else{
            $(" .paymentDetails .accordion" ).siblings(".panel").addClass('activated');
        }
      });

}

function returnInShippingForm() {
    //$(".billing-address").show();
    $("#unregistered_form").parent('.panel').addClass('activated');
    $(".shipping-step .accordion").css("pointer-events","auto");
    $("#shippingInformation").removeClass("activated");
    $(".return-details-wrapper").addClass('activated');
    $(".have_an_account").show()

    //payment
    $(".paymentDetails .accordion").css("pointer-events","none");
    $(".paymentDetails .accordion").removeClass('accordion-active');
    if (isPersol) $('.paymentDetails').css('opacity','.6');
    $("#loaderForview").removeClass('activated');
    $('#loaderForview').css('height','0');

}

function loadAddressInfo() {
                
    var url = '/wcs/resources/store/'+WCParamJS.storeId+'/person/@self/contact';
    if(userType === 'R') {
        //getAjaxCallInfo(url, null, orderBillingAddressRegCallback);
    } if (userType === 'G') {
        //getAjaxCallInfo(url, null, orderBillingAddressCallback);
    }
    loadPaymentView();
 
}

function paymentsMethodSetup(){

    $("#shippingBillingRecap-wrapper a").attr('data-element-id','X_X_Return_Pay');

    if(window.ApplePaySession){
        $('.payment-method-block--text-ApplePay').parent().show();
        $('.payment-method--text--input-Cybersource').removeAttr('checked');
        
        if(isOliver){
            $('.card-info-fields').hide(); 
            $('#shippingBillingPageNext').parent().hide();
        }else if(isPersol) {
            $('.card-info').hide();
            $('#shippingBillingPageNext').hide();
        }
        $('.payment-method-block--text-ApplePay').prop('checked', true);   
    }

    $('.payment-method--text input').click(function () {
        $('.payment-method--text input').removeAttr('checked');
        $(this).attr('checked');
        if ($(this).hasClass('payment-method--text--input-Cybersource')) {
            $('.payment-method').val('payMethodId_1');
            if(isOliver){
                $('.card-info-fields').show(); 
             //   $('#applePayButtonDiv').parent().hide(); /** DRF -> NERD-309 ApplePay */
                $('#shippingBillingPageNext').parent().show();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
            }else if(isPersol){
                $('.card-info').show();
                $('#shippingBillingPageNext').show();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingAffirm').hide();
            }  
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        } else if ($(this).hasClass('payment-method--text--input-PayPal')) {
            $('.payment-method').val('payMethodId_2');
            if(isOliver){
                $('.card-info-fields').hide();
              //  $('#applePayButtonDiv').parent().hide(); /** DRF -> NERD-309 ApplePay */
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingPayPal').parent().show();
                $('#shippingBillingAffirm').parent().hide();

            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingPayPal').show();
                $('#shippingBillingAffirm').hide();
            }
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        } else if ($(this).hasClass('payment-method-block--text-ApplePay')) {
            $('.payment-method').val('payMethodId_3');
            if(isOliver){
                $('.card-info-fields').hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
                //$('#applePayButtonDiv').parent().show();
            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingAffirm').hide();
            }
            $('#applePayButtonDiv').show();
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        /**
         * END - DRF -> NERD-309 ApplePay
         */
        } else if ($(this).hasClass('payment-method--text--input-Affirm')) {
            $('.payment-method').val('payMethodId_4');
            
            if(isOliver){ 
                $('.card-info-fields').hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingAffirm').parent().show();
               // $('#applePayButtonDiv').parent().hide();

            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingAffirm').show();
            }
            $('#applePayButtonDiv').hide();
            $('.affirm-redirect-msg').show();
            $('#klarna-payments-container').empty();
        }
        /**
         * Klarna
         */
        else if ($(this).hasClass('payment-method--text--input-Klarna')) {
            $('.payment-method').val('payMethodId_5');
            if(isOliver){
                $('.card-info-fields').hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
                $('#shippingBillingKlarna').parent().show();
                // $('#applePayButtonDiv').parent().hide();
            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingAffirm').hide();
                $('#shippingBillingKlarna').show();
            }
            $('#applePayButtonDiv').hide();
            $('.affirm-redirect-msg').hide();
            /* in case of change radio button and return in radio klarna then show */
            $('#klarna-payments-container').show();

            /* Init SDK Klarna and load the Klarna widget*/
            if($('#WC_Klarna_Session_Client_token').val() &&
                $('#WC_Klarna_Session_Client_requestid').val()){

                $('#loader_klarna').show();

                /* Perform an ajax call to update the session with user's billing informations*/
                var params = {};

                params.orderId = $('#WC_CheckoutPaymentsAndBillingAddressf_orderId_1').val();
                params.storeId = WCParamJS.storeId;
                params.billing_address_id = $('[name=billing_address_id] [selected=selected]').attr('value');
                params.requestID = $('#WC_Klarna_Session_Client_requestid').val();
                params.nameStore = WCParamJS.countryCode.toUpperCase();

                var countryCode = WCParamJS.countryCode.toUpperCase();
                if (countryCode == 'UK') {
                    countryCode = 'GB';
                }

                params.lang = locale.substring(0,2).toUpperCase() + "-" + countryCode;

                wcService.declare({
                    id: "KlarnaUpdateSessionCmd",
                    actionId: "KlarnaUpdateSessionCmd",
                    url: "KlarnaUpdateSessionCmd",

                    successHandler: function (resKlarnaUpdate) {
                        console.log(resKlarnaUpdate);
                        try {
                            $('#loader_klarna').hide();
                            Klarna.Credit.load({
                                container: '#klarna-payments-container'
                            }, function (res) {
                                if (res["show_form"] == false) {
                                    if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                                        MessageHelper.displayErrorMessage("Beim Laden des Klarna Payment Widget ist ein Fehler aufgetreten.");
                                    } else{
                                        MessageHelper.displayErrorMessage("There was an error loading Klarna Payment Widget.");
                                    }
                                }
                            })
                        } catch (e) {
                            console.log(e);
                        }
                        $('.loader_klarna-container').width($('#klarna-credit-main').width());
                    },
                    failureHandler: function (resKlarnaUpdate) {
                        if (resKlarnaUpdate.errorMessage) {
                            MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessage);
                        } else {
                            if (resKlarnaUpdate.errorMessageKey) {
                                MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessageKey);
                            }
                        }
                    }
                });

                wcService.invoke("KlarnaUpdateSessionCmd", params);
        	}
        }
    });

    if ( page == 'returnDetails' ){
        var affirmMethod = $(".return-details-page .payment-method--text--input-Affirm");
        $(affirmMethod).parents(".payment-method--text").remove();
    }
}

/*
function orderBillingAddressCallback(response) {
    var suffix = '_orderSummary';
    var userType = '${userType}';
    var currentAddress = '';
    var html = '';
    if(response.contact && userType === 'G') {
        for(var i = 0; i<response.contact.length; i++) {
            currentAddress = response.contact[i];
            if(response.contact[i].addressType &&  response.contact[i].addressType == 'Billing') {
               getAddressDisplay(suffix, currentAddress, '${setAsVar}', '${cachedOnlineStoreMapJSON}', '${setIsOrg}', '#billingAddressDisplayArea_<c:out value="${param.paymentAreaNumber}"/> .billingAddress');
            
            }else if(response.contact[i].addressType && response.contact[i].addressType == 'ShippingAndBilling'){

                getAddressDisplay(suffix, currentAddress, '${setAsVar}', '${cachedOnlineStoreMapJSON}', '${setIsOrg}', '#billingAddressDisplayArea_<c:out value="${param.paymentAreaNumber}"/> .billingAddress');
                getAddressDisplay(suffix, currentAddress, '${setAsVar}', '${cachedOnlineStoreMapJSON}', '${setIsOrg}', '#billingAddressDisplayArea_<c:out value="${param.paymentAreaNumber}"/> .shippingAddress');
            }else{
                getAddressDisplay(suffix, currentAddress, '${setAsVar}', '${cachedOnlineStoreMapJSON}', '${setIsOrg}', '#billingAddressDisplayArea_<c:out value="${param.paymentAreaNumber}"/> .shippingAddress');
            }
        }
    } else if(userType === 'R') {
        currentAddress = response;
    }
    if(currentAddress && currentAddress.addressId && currentAddress.country) {
    //    getAddressDisplay(suffix, currentAddress, '${setAsVar}', '${cachedOnlineStoreMapJSON}', '${setIsOrg}', '#billingAddressDisplayArea_<c:out value="${param.paymentAreaNumber}"/> .address');                    
    }

    //show info and deleted form 
   goToPaymentStep();
   loadPaymentView();
}
*/

/**
* This function is only used by reg Users to get the information of the primary address
*/
/*
function orderBillingAddressRegCallback(response) {
    var regUrl = '/wcs/resources/store/${WCParam.storeId}/person/@self/contact/byAddressId/' + response.addressId;
    getAjaxCallInfo(regUrl, null, orderBillingAddressCallback);
}
*/

function loadPaymentView(){
    requestSubmitted = true;

    goToPaymentStep();

    function removePaymentLoader(){
        $( "#loadingPaymentDiv" ).fadeOut(500, function() {
          // fadeOut complete. Remove the loading div
          $( "#loadingPaymentDiv" ).remove(); //makes page more lightweight 
          $('#loaderForview,.paymentDetails').css('height','auto');
      });  
    }

    var url = (isInToolkit ? "/webapp/wcs/stores/servlet" : "")+"/PaymentView?orderId="+$('#currentOrderId').val() +"&langId="+ WCParamJS.langId+"&catalogId=" +   WCParamJS.catalogId + "&storeId="+ WCParamJS.storeId + "&showRegTag=T";
    
    $.ajax({
        method: "GET",
        url: url,
        success: function(data, textStatus, jqXHR){
            removePaymentLoader();
            $('#loaderForview').html(data).promise().done(function(){
                var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
                if(!sameaddressCheckbox.checked && klarnaEnabled == 'true'){ //hide klarna if billing and shipping address are different
                    $('.payment-method--text--input-Klarna').parent().hide();
                }
                if (klarnaEnabled == 'true') {
                    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
                }
            });
            paymentsMethodSetup();
        }
    });
}

function shipmentChecked(){
    if($('#page').hasClass('checkout-page')){
        operationInCheckOutPage();
    }else{
        operationInCartPage();
    }
    placeDeliveryDate();
}

function operationInCheckOutPage(){
    if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        //in this cases we must see zipcode research and recipient
        $('#recipient_detail').show();	
        if(window.mobilecheck() || window.tabletPortraitCheck()) {
            $('#callStorePickUp').css('display','block'); 
        }else{
            $('#callStorePickUp').css('display','flex');
        }		
        $('#shippingCreateEditArea1').hide();
        $('[for="SameShippingAndBillingAddress"]').hide();
        $('#SameShippingAndBillingAddress').prop('checked', false);
        $('#billingAddressCreateEditFormDiv_1').show();
    }else{
        $('#recipient_detail').hide();	
        $('#callStorePickUp').hide();
        $('#shippingCreateEditArea1').show();
        $('billingCreateEditArea1').hide();
        $('#SameShippingAndBillingAddress').prop('checked', true);
        $('[for="SameShippingAndBillingAddress"]').show();
        $('#billingAddressCreateEditFormDiv_1').hide();
    }

    ajaxCallCart();//for checkout 3_0
}

function operationInCartPage(){
    ajaxCallCart();
    hidePayPalExpress();
}

function hidePayPalExpress(){
    if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        $('.checkout_or_seperator').hide();
        $('.paypal_button_container').hide();
        $('.klarna_button_container').hide();
    }else{
        $('.checkout_or_seperator').show();
        $('.paypal_button_container').show();
        $('.klarna_button_container').show();
    }
}

function placeDeliveryDate() {
    if ($("input[name='singleShipmentShippingMode']:checked").attr("shipmodecode") == "GreenShipping") {
        $('.item-delivery-date.rx .estimated-date').text($('#leadTimeRxGs').val()+" ");
        $('.item-delivery-date.rx .estimated-date').after("<span class='estimated-prescription'>"+ "(" + $('#prescription_copy').val()+")"+ "</span>");
        $('.item-delivery-date.monogram .estimated-date').text($('#leadTimeMonogramGs').val());
        $('.item-delivery-date:not(.rx):not(.monogram) .estimated-date').text($('#leadTimeGs').val());
    } else {
        $('.item-delivery-date.barberini .estimated-date').text($('#leadTimeBarb').val()+" ");
        $('.item-delivery-date.barberini .estimated-date').after("<span class='estimated-prescription'>"+"("+$('#prescription_copy').val()+")"+"</span>");
        $('.item-delivery-date.rx:not(.barberini) .estimated-date').text($('#leadTimeRx').val()+" ");
        $('.item-delivery-date.rx:not(.barberini) .estimated-date').after("<span class='estimated-prescription'>"+"("+$('#prescription_copy').val()+")"+"</span>");
        $('.item-delivery-date.monogram .estimated-date').text($('#leadTimeMonogram').val());
        $('.item-delivery-date:not(.rx):not(.monogram) .estimated-date').text($('#leadTime').val());
    }
    //$('.checkout-page.checkout .item-delivery-date .estimated-date').html($('.checkout-page.checkout .item-delivery-date .estimated-date').html().replace("-","- </br>"));
    $('.checkout-page .item-delivery-date .estimated-date').each(function(idx,item) {
        $(item).html($(item).html().replace("-","- </br>"));
    });
}

function perksInitialization(){

    if($('#greenShippingIsAvailable').val()== 'false' || sessionStorage.greenShippingAvailable == 'false'){ //hides green shipping in the perks if it is not an available mode
        $('.perks_container .perks_content .product-green-shipping').hide();
    }else{
        $('.perks_container .perks_content .product-green-shipping').show();
    }

    $(".overlay").click(function(event) {
        var id = $(this).attr('href');
        

        if($(id).hasClass('activated-perks')){
            $(id).removeClass('activated-perks');
        }else{
            $(id).addClass('activated-perks')
        }

        $(id +' .close').click(function(event) {
            $(id).removeClass('activated-perks');
        });
        $(id).click(function(event) {
            if (event.target !== event.currentTarget){ //disabled click on pop-up
                 return
                }else{
                    $(id).removeClass('activated-perks');
                } 
        });
       
    })
}

function openConfimationPopUp(){

    $("html, body").animate({ scrollTop: 0 }, 600);

    $("#ConfirmationArea").fadeIn(200);
    $("#ConfirmationArea").addClass('active');
}

function closeConfimationPopUp(){

    $("#ConfirmationArea").fadeOut(200);
    $("#ConfirmationArea").removeClass('active');
}

function deleteOrder(orderId,urlRedirect){

    if(orderId != null && orderId != undefined){
        
        for (var product in tealiumProducts){
            tealiumProducts[product]['CancelledUnits'] = "1";
            tealiumProducts[product]['CancelledAmount'] = tealiumProducts[product]['Price'];
        }

        tealium_data2track.push({
            'id':'Event',
            'Order_CancellationId' : orderId,
            'Events_OrderCancel': "1",
            'products' : tealiumProducts
        });
        //var cancelOrderURL = (isInToolkit ? "/webapp/wcs/stores/servlet" : "")+"/AdminOrderCancel?orderId="+orderId +"&langId="+WCParamJS.langId+"&storeId="+WCParamJS.storeId+"&URL="+urlRedirect;
        var cancelOrderURL = (isInToolkit ? "/webapp/wcs/stores/servlet" : "")+"/OrderCancel?orderId="+orderId +"&langId="+WCParamJS.langId+"&storeId="+WCParamJS.storeId+"&URL="+urlRedirect+"&keepPaymentInstructions=true";
        location.href = cancelOrderURL;
        
    }
}

/*function goToUps(trackingNumber){
    var urlTrack = "https://www.ups.com/track?tracknum=" + trackingNumber;
    window.open(urlTrack, "_blank");
}*/

function manageReasonsDropdown(){
    $(document).off("click", ".reasons-dropdown").on("click", ".reasons-dropdown", function(){
        $('body').addClass('dropdown-opened');
        if (!$(this).find(".dropdown").hasClass("open")){
            $(this).find(".dropdown").addClass("open");
            $(this).find(".dropdown button").attr("data-extended","true");
            $('#contentWrapper').css('margin-bottom', '35vh')
        } else {
            $('body').removeClass('dropdown-opened');
            $(this).find(".dropdown").removeClass("open");
            $(this).find(".dropdown button").attr("data-extended","false");
            $('#contentWrapper').css('margin-bottom', '0')
        }
    });  
    
    if($( ".reasons-dropdown").length) {
        $(document).on("click", 'body.dropdown-opened *:not(.reasons-dropdown)', function() {
            $('body').removeClass('dropdown-opened');
            $( ".reasons-dropdown").find(".dropdown").removeClass("open");
            $( ".reasons-dropdown").find(".dropdown button").attr("data-extended","false");
            $('#contentWrapper').css('margin-bottom', '0')
        })
    }

    $(".reasons-dropdown .dropdown-menu li").click(function(){
        var selText = $(this).text();
        var selCode = $(this).attr("data-reason-code");
        $(this).parents('.dropdown').find("[id^='reasons-dropdown-button']").attr("selected-code",selCode).html(selText+' <span class="arrow"></span>');
        var selectedReasonCode = $(this).parents('.dropdown').find("[id^='reasons-dropdown-button']").attr("selected-code");
        // If no reason is selected, do not go to next step
        if (selectedReasonCode != undefined) {
            $(this).parents('.dropdown').find("[id^='reasons-dropdown-button']").removeClass("invalid");
        }
    });
}

function showHideOrderDetails(){
    $(document).off("click", ".shipping-billing-details .view-details").on("click", ".shipping-billing-details .view-details", function() {
        var addressWrapper = $(this).parent();
        if (!addressWrapper.hasClass("open")){
            addressWrapper.addClass("open");
        } else addressWrapper.removeClass("open");
    });
}

function showProceedToReturnButton() {
    if (window.mobilecheck() || window.tabletPortraitCheck()){
        var mobileReturnCheckboxs = $("[id^='orderItem'] .item-footer-mobile .checkbox input:checked");
        if (mobileReturnCheckboxs.length > 0) {
            $(".shopping-bag-page__right .cta-container .proceed").addClass("show");
        } else $(".shopping-bag-page__right .cta-container .proceed").removeClass("show");
    } else {
        var desktopReturnCheckboxs = $("[id^='orderItem'] .item-footer-desktop .checkbox input:checked");
        if (desktopReturnCheckboxs.length > 0) {
            $(".shopping-bag-page__right .cta-container .proceed").addClass("show");
        } else $(".shopping-bag-page__right .cta-container .proceed").removeClass("show");
    }
}

/* This function retrieves checked items params to create an url*/

function createCheckedItemsParamsUrl() {

    var checkedItemsUrl = "";
    var countSelectedReasons = 0;
    var numCheckedItems = 0;
    var lastIndex = 0;

    numCheckedItems = $("#orderItems .grid-container .checkbox.checked").length;

    $("#orderItems .grid-container").each(function(idx, item){
        if ($(item).find(".checkbox.checked").length > 0){
            var selectedReasonCode = $(item).find("[id^='reasons-dropdown-button']:visible").attr("selected-code");
            // If no reason is selected, do not go to next step
            if (selectedReasonCode == undefined) {
                $(item).find("[id^='reasons-dropdown-button']").addClass("invalid");
            } else {
                $(item).find("[id^='reasons-dropdown-button']").removeClass("invalid");
                countSelectedReasons++;
                var returnItemInfo = JSON.parse($(item).find("[name^='orderItemObj']").val());
                var url = '&orderItemId_' + lastIndex + '=' + returnItemInfo["orderItemId"] +
                          '&quantity_' + lastIndex + '=' + returnItemInfo["quantity"] +
                          '&reason_' + lastIndex + '=' + selectedReasonCode;
                          lastIndex++;
                if ($(item).find("[name^='orderItemIsRx']").length > 0 && $(item).find("[name^='orderItemIsRx']").val() == "true"){
                    // add lens params to url
                    url = url + '&orderItemId_' + lastIndex + '=' + returnItemInfo["lensItemId"] +
                                '&quantity_' + lastIndex + '=' + returnItemInfo["lensQuantity"] +
                                '&reason_' + lastIndex + '=' + selectedReasonCode;
                                lastIndex++;
                    // add first service params to url
                    url = url + '&orderItemId_' + lastIndex + '=' + returnItemInfo["serviceItemId_0"] +
                                '&quantity_' + lastIndex + '=' + returnItemInfo["serviceQuantity_0"] +
                                '&reason_' + lastIndex + '=' + selectedReasonCode;
                                lastIndex++;
                    // add second service params to url
                    url = url + '&orderItemId_' + lastIndex + '=' + returnItemInfo["serviceItemId_1"] +
                                '&quantity_' + lastIndex + '=' + returnItemInfo["serviceQuantity_1"] +
                                '&reason_' + lastIndex + '=' + selectedReasonCode;
                                lastIndex++;
                }
                if (isPersol && $(item).find("[name^='isMonogramItem']").length > 0){
                    // add monogram params to url
                    returnItemInfo = JSON.parse($(item).find("[name^='monogramObj']").val());
                    url = url + '&orderItemId_' + lastIndex + '=' + returnItemInfo["engrItemId"] +
                                '&quantity_' + lastIndex + '=' + returnItemInfo["engrQuantity"] +
                                '&reason_' + lastIndex + '=' + selectedReasonCode;
                                lastIndex++;
                }
                checkedItemsUrl = checkedItemsUrl + url;
            }            
        }
    });
    
    
    
    checkedItemsUrl = checkedItemsUrl + '&shipping_service_choice=' + $('#rmaTypes').attr('value').split(';')[0]; //virtual label as default label choice

    // If all reasons are selected, create return
    if (numCheckedItems == countSelectedReasons) {

        if ($("#proceedToCheckout").length == 0){
            //  Checkout button is not present
            if ($("#returnShippingPrice").val() != '' && $("#returnShippingPrice").val() > 0){
                //  Paid Checkout
                $("div[data-espot-name='X_OrderFlow_PerksTop']").hide();
                var shippingChargeCatEntryId = $("#shippingChargeCatEntryId").val();
                if (shippingChargeCatEntryId != ''){
                    //  First, clean the current cart
                    cleanCartForShipOrder(true,function() {
                        //  Then, add Shipping Charge item
                        productDisplayJS.AddItem2ShopCartRMA(shippingChargeCatEntryId, 1);
                        showLoaderInButton('proceedWithReturn');
                        $("#proceedWithReturn span").html("")
                        renderOrderSummary();
                        $("#checkout-order-summary").show();
                        createProceedToCheckoutBtn();
                    });
                } else {
                    //  TODO: Manage error case
                }
            } else {
                //  Free Checkout
                showLoaderInButton('proceedWithReturn');
                $("#proceedWithReturn span").html("");
                createItemsReturn(checkedItemsUrl, 0);
            }
        } else {
            //  Checkout button is present
            $("#goReturnCheckout").on("click", function(){
                showLoaderInButton('goReturnCheckout');
                $("#goReturnCheckout span").html("");
                getShippingChargeOrderId(checkedItemsUrl);
            });
        }
    }
}

function getShippingChargeOrderId(checkedItemsUrl){
    var shippingChargeOrderId;
    $.ajax({
        url: $checkoutObj.cartServiceUrl(),
        type: 'GET',
        async: false,
        success: function(data) {
        	if (data.recordSetTotal > 0) {
                return shippingChargeOrderId = data.orderId;
            }
        },
        error: function(error) {
            return error;
        }
    });

    createItemsReturn(checkedItemsUrl, shippingChargeOrderId);
}

function createProceedToCheckoutBtn(){
    
    removeCheckoutLoader();

    proceedCheckoutBtn = '';
    proceedCheckoutBtn += '<div class="button proceedCheckout" id="proceedToCheckout">';
    proceedCheckoutBtn += '<a tabindex="0" role="button" class="button__checkout font-caboto medium loaderButton" id="goReturnCheckout" data-element-id="X_X_Return_Checkout">';
    proceedCheckoutBtn += '<span>';
    proceedCheckoutBtn += $("[name='proceedCheckoutText']").val();
    proceedCheckoutBtn += '</span>';
    proceedCheckoutBtn += '</a>';
    proceedCheckoutBtn += '</div>';

    //If there's a shipping charge, remove Proceed with return button and display Proceed to checkout
    $(".create-return-page #WC_CheckoutLogonf_div_3").remove();
    $(".create-return-page .cta-container").prepend(proceedCheckoutBtn);
    createCheckedItemsParamsUrl();
}

function createItemsReturn(checkedItemsUrl, shippingChargeOrderId) {
    if (checkedItemsUrl != null && checkedItemsUrl != undefined) {
        var returnDetailsURL = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + 'ReturnDetailsView';
        var createReturnService = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + "ReturnItemAdd?storeId=" + WCParamJS.storeId + "&RMAId=**" + checkedItemsUrl + "&shippingChargeOrderId=" + shippingChargeOrderId + "&URL=" + returnDetailsURL;
        location.href = createReturnService;
    }
}

function updateItemsReturn(selectedLabel) {

    var rmaItemIdsArr = $("#rmaItemsIds").val().replace(/[\[\]']+/g,'').split(',');
    var rmaItemId = "";
    var url = "";

    for (var i = 0; i < rmaItemIdsArr.length; i++) {
        rmaItemId = rmaItemIdsArr[i].trim();
        url = url + "&RMAItemId_" + i + "=" + rmaItemId;
    }

    if (url != null && url != undefined) {
        var selectedShippingLabel = "&shipping_service_choice=" + selectedLabel;
        var updateReturnService = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + "ReturnItemUpdate?storeId=" + WCParamJS.storeId + url + selectedShippingLabel + "&URL=ReturnDetailsView";
        
        $.ajax({
            method: "POST",
            url: updateReturnService,
            success: function(){
                console.log("Return item updated successfully");
            },
            error: function() {
                console.error("Return item update failed");
            }
        });
    }
}

function processRma() {

    var rmaId = $("#rmaId").val();
    var params = 'RMAId=' + rmaId + '&storeId=' + WCParamJS.storeId + '&catalogId=' + WCParamJS.catalogId + '&langId=' + $("#languageId").val()+ '&orderId=' + $('#rmaOrderId').val();

    var returnThankYouPageURL = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + 'ReturnThankYouPageView?' + params;
    var prepareReturnService = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + "OnlineReturnProcess?storeId=" + WCParamJS.storeId + '&RMAId=' + rmaId/* + "&URL=" + returnThankYouPageURL*/;

    $.ajax({
        method: "GET",
        url: prepareReturnService,
        success: function(data){
        	$('#confirmReturnNoCheckout').css('background-color','grey');
        	$('#confirmReturnNoCheckout').attr('disabled','disabled');
            window.location.href = returnThankYouPageURL;
        },
        error: function(data){
            deletePaymentLoaderOverlay();
            MessageHelper.displayErrorMessage("There was a problem while confirming the return data.");
            cursor_clear();
        }
    });
    
}

function cancelRma() {

    var rmaId = $("#rmaId").val();

    if(typeof rmaId == 'undefined'){
        rmaId = window.sessionStorage.getItem("rmaId");
    }
    var rmaOrderId = $("#rmaOrderId").val();

    if(typeof rmaOrderId == 'undefined'){
        rmaOrderId = window.sessionStorage.getItem("rmaOrderId");;
    }

    var langId=$("#languageId").val();

    if(typeof langId == 'undefined'){
        langId = WCParamJS.langId;
    }


    var params = '?storeId=' + WCParamJS.storeId + '&catalogId=' + WCParamJS.catalogId + '&langId=' + langId + '&orderId=' + rmaOrderId;

    var createReturnURL = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + 'CreateReturnView' + params;
    var deleteReturnService = "/wcs/resources/store/" + WCParamJS.storeId + "/ordersrma/management/deleteRma?storeId=" + WCParamJS.storeId + "&RMAId=" + rmaId ; 

    $.ajax({
        method: "POST",
        url: deleteReturnService,
        success: function(data){
            window.location.href = createReturnURL;
        },
        error: function(data){
            MessageHelper.displayErrorMessage("There was a problem while deleting the rma.");
        }
    });

}


function goToOnlineReturnTYP() {
    var rmaId = $("#rmaId").val();
    var chargeId = ($('#chargeOrderId').val() != undefined && $('#chargeOrderId').val() != '' ) ? $('#chargeOrderId').val() : '0';
    var params = 'RMAId=' + rmaId + '&storeId=' + WCParamJS.storeId + '&catalogId=' + WCParamJS.catalogId + '&langId=' + $("#languageId").val()+ '&orderId=' + $('#rmaOrderId').val() + '&chargeOrderId=' + chargeId;
    var returnThankYouPageURL = (isInToolkit ? "/webapp/wcs/stores/servlet/" : "") + 'ReturnThankYouPageView?' + params;
    window.location.href = returnThankYouPageURL;
}

const orderError = 'orderError';
const emailError = 'emailError';
var isOrderError = 0;
var isEmailError = 0;

function checkIsTheOnlyError(typeError){
	var resp = true;
	if(typeError == orderError && isEmailError == 1){
		isOrderError = 0;
		isEmailError = 0;
		$('.address-erros-message-cont').remove();
		$('.address-field-error-message--email').remove();
		resp = false;
	}else if(typeError == orderError && isEmailError == 0){
		isOrderError = 1;
	}else if(typeError == emailError && isOrderError == 0){
		isEmailError = 1;
	}else if(typeError == emailError && isOrderError == 1){
		isOrderError = 0;
		isEmailError = 0;
		$('.address-erros-message-cont').remove();
		$('.address-field-error-message--email').remove();
		resp = false;
	}
	return resp;
}

function validateEmailFormTMO(formField, isMandatory) {
    var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    AddressHelper.removeFieldErrorMessages(formField);
    var formFieldValue = trim(formField.value);
    var isEmpty = formFieldValue == "";
    var isValid = true;

    AddressHelper.removeFieldErrorMessages(formField);
    $(formField).next().removeClass('labelOnTop');
    if (isEmpty && isMandatory) {
        isValid = false;
        if(checkIsTheOnlyError(emailError)){
        	AddressHelper.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailEmpty"]);
        }else{
        	AddressHelper.manageMultipleEmptyFields(formField,MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
        }
    } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
        isValid = false;
        if(checkIsTheOnlyError(emailError)){
        	AddressHelper.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailTooLong"]);
        }else{
        	AddressHelper.manageMultipleEmptyFields(formField,MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
        }
        tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
    } else if (!emailRegexp.test(formFieldValue)) {
        isValid = false;
        if(checkIsTheOnlyError(emailError)){
        	AddressHelper.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        }else{
        	AddressHelper.manageMultipleEmptyFields(formField,MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
        }
        tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
    } else {
        //We have to clear input's email value before setting it again because of
        //the "special" behavior of the <input type="email"> tag containing spaces
    	isEmailError = 0;
    	formField.value = "";
        formField.value = formFieldValue;
    }

    if (isValid) {
    	AddressHelper.addSuccesIcon(formField);
        return true;
    }else if(!isEmpty){
        $(formField).next().addClass('labelOnTop');//class that block label on top when the email is invalid and not empty
    }

    AddressHelper.removeSuccesIcon(formField);
    return false;
}

function validateTrackOrderForm(form){
    var emailisValid = true;
    var orderIDisValid = true;

    if(form['email'].value == '' || form['email'].value == undefined){
    	hideGenericError();
    	if(checkIsTheOnlyError(emailError)){
    		AddressHelper.validateEmailFormField(form['email'],true);
    	}else{
    		AddressHelper.manageMultipleEmptyFields(form['email'],MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
    	}
        restoreAjaxButtons();
        emailisValid = false;
    }else if (form['orderId'].value == "" || form['orderId'].value == undefined){
    	hideGenericError();
    	if(checkIsTheOnlyError(orderError)){
    		AddressHelper.manageMultipleEmptyFields(form['email'],MessageHelper.messages["ERROR_OrderIdEmpty"], false);
           
    	}else{
    		MessageHelper.messages["EMAIL_AND_ORDER_ERROR"]
    	}
    	$('.input-style input#OrderId').parent().addClass('isNotValid');
    	if(isPersol){
    		$('.input-style input#OrderId').parent().removeClass('validCheck');
    		$('.input-style input#OrderId').addClass('field-error-message');
    	}
        restoreAjaxButtons();
        orderIDisValid = false;
    }else if( !/^\d+$/.test(form['orderId'].value)){
    	hideGenericError();
    	if(checkIsTheOnlyError(orderError)){
    		AddressHelper.manageMultipleEmptyFields(form['email'],MessageHelper.messages["ERROR_INVALIDORDERFORMAT"], false);
        }else{
        	AddressHelper.manageMultipleEmptyFields(form['email'],MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
    	}
    	$('.input-style input#OrderId').parent().addClass('isNotValid');
    	if(isPersol){
    		$('.input-style input#OrderId').parent().removeClass('validCheck');
    		$('.input-style input#OrderId').addClass('field-error-message');
    	}
        restoreAjaxButtons();
    	orderIDisValid = false;
    }else if(form['email'].value != ''){
    	hideGenericError();
    	if(checkIsTheOnlyError(emailError)){
    		emailisValid =AddressHelper.validateEmailFormField(form['email'],true);
        }else{
        	AddressHelper.manageMultipleEmptyFields(form['email'],MessageHelper.messages["EMAIL_AND_ORDER_ERROR"], false);
    	}
    	
    }

    if(emailisValid && orderIDisValid){
        form['orderId'].value = form['orderId'].value.trim();
        return true;
    }else{
        restoreAjaxButtons();
        return false;
    }

    
}

function hideGenericError(){
	if($('.error-container').css('display') != 'none'){
		$('.error-container').hide();
	}
}

function findOrder(formName){
    var form = document.forms[formName];
    var isFormValid = validateTrackOrderForm(form);
    var urlActualPage = window.location.href;
    
    sessionStorage.removeItem('rmaCreated');

    if(isFormValid){
        setTimeout(function(){
            form.submit();
        }, 1500);
    }
}


function returnInShippingForm() {
    //$(".billing-address").show();
    $("#unregistered_form").parent('.panel').addClass('activated');
    $(".shipping-step .accordion").css("pointer-events","auto");
    $("#shippingInformation").removeClass("activated");
    $(".return-details-wrapper").addClass('activated');
    $(".have_an_account").show()
    $('#prescription-message').removeClass('prescription_message_payment_step');
    $('.shipping-step').removeClass('shipping-step_payment_section_activated');

    //payment
    $(".paymentDetails .accordion").css("pointer-events","none");
    $(".paymentDetails .accordion").removeClass('accordion-active');
    if (isPersol) $('.paymentDetails').css('opacity','.6');
    if (isOliver) $('.paymentDetails').css('opacity','.5');
    $("#loaderForview").removeClass('activated');
    $('#loaderForview').css('height','0');

}

function loadAddressInfo() {
                
    var url = '/wcs/resources/store/'+WCParamJS.storeId+'/person/@self/contact';
    if(userType === 'R') {
        //getAjaxCallInfo(url, null, orderBillingAddressRegCallback);
    } if (userType === 'G') {
        //getAjaxCallInfo(url, null, orderBillingAddressCallback);
    }
    loadPaymentView();
 
}

function paymentsMethodSetup(){

    $("#shippingBillingRecap-wrapper a").attr('data-element-id','X_X_Return_Pay');
    $("#shippingBillingRecap-wrapper a div").html($("input[name=paymentButtonText]").val());

    if(window.ApplePaySession){
        $('.payment-method-block--text-ApplePay').parent().parent().show();
        $('.payment-method--text--input-Cybersource').removeAttr('checked');
        
        if(isOliver){
            $('.card-info-fields').hide(); 
            $('#shippingBillingPageNext').parent().hide(); 
        }else if(isPersol) {
            $('.card-info').hide();
            $('#shippingBillingPageNext').hide();
            $('.apple-pay-button').show();
        }
        $('.payment-method-block--text-ApplePay').prop('checked', true);   
    }

    $('.payment-method--text input').click(function () {
        $('.payment-method--text input').removeAttr('checked');
        $(this).attr('checked');
        if ($(this).hasClass('payment-method--text--input-Cybersource')) {
            $('.payment-method').val('payMethodId_1');
            if(isOliver){
                $('.card-info-fields').show(); 
             //   $('#applePayButtonDiv').parent().hide(); /** DRF -> NERD-309 ApplePay */
                $('#shippingBillingPageNext').parent().show();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
            }else if(isPersol){
                $('.card-info').show();
                $('#shippingBillingPageNext').show();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingAffirm').hide();
            }  
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        } else if ($(this).hasClass('payment-method--text--input-PayPal')) {
            $('.payment-method').val('payMethodId_2');
            if(isOliver){
                $('.card-info-fields').hide();
              //  $('#applePayButtonDiv').parent().hide(); /** DRF -> NERD-309 ApplePay */
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingPayPal').parent().show();
                $('#shippingBillingAffirm').parent().hide();

            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingPayPal').show();
                $('#shippingBillingAffirm').hide();
            }
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        } else if ($(this).hasClass('payment-method-block--text-ApplePay')) {
            $('.payment-method').val('payMethodId_3');
            if(isOliver){
                $('.card-info-fields').hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
                //$('#applePayButtonDiv').parent().show();
            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingAffirm').hide();
            }
            $('#applePayButtonDiv').show();
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        /**
         * END - DRF -> NERD-309 ApplePay
         */
        } else if ($(this).hasClass('payment-method--text--input-Affirm')) {
            $('.payment-method').val('payMethodId_4');
            
            if(isOliver){ 
                $('.card-info-fields').hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingKlarna').parent().hide();
                $('#shippingBillingAffirm').parent().show();
               // $('#applePayButtonDiv').parent().hide();

            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingKlarna').hide();
                $('#shippingBillingAffirm').show();
            }
            $('#applePayButtonDiv').hide();
            $('.affirm-redirect-msg').show();
            $('#klarna-payments-container').empty();
        }
        /**
         * Klarna
         */
        else if ($(this).hasClass('payment-method--text--input-Klarna')) {
            $('.payment-method').val('payMethodId_5');
            if(isOliver){
                $('.card-info-fields').hide();
                $('#shippingBillingPageNext').parent().hide();
                $('#shippingBillingPayPal').parent().hide();
                $('#shippingBillingAffirm').parent().hide();
                $('#shippingBillingKlarna').parent().show();
                // $('#applePayButtonDiv').parent().hide();
            }else if(isPersol){
                $('.card-info').hide();
                $('#shippingBillingPageNext').hide();
                $('#shippingBillingPayPal').hide();
                $('#shippingBillingAffirm').hide();
                $('#shippingBillingKlarna').show();
            }
            $('#applePayButtonDiv').hide();
            $('.affirm-redirect-msg').hide();
            /* in case of change radio button and return in radio klarna then show */
            $('#klarna-payments-container').show();

            /* Init SDK Klarna and load the Klarna widget*/
            if($('#WC_Klarna_Session_Client_token').val() &&
                $('#WC_Klarna_Session_Client_requestid').val()){

                $('#loader_klarna').show();

                /* Perform an ajax call to update the session with user's billing informations*/
                var params = {};

                params.orderId = $('#WC_CheckoutPaymentsAndBillingAddressf_orderId_1').val();
                params.storeId = WCParamJS.storeId;
                params.billing_address_id = $('[name=billing_address_id] [selected=selected]').attr('value');
                params.requestID = $('#WC_Klarna_Session_Client_requestid').val();
                params.nameStore = WCParamJS.countryCode.toUpperCase();

                var countryCode = WCParamJS.countryCode.toUpperCase();
                if (countryCode == 'UK') {
                    countryCode = 'GB';
                }

                params.lang = locale.substring(0,2).toUpperCase() + "-" + countryCode;

                wcService.declare({
                    id: "KlarnaUpdateSessionCmd",
                    actionId: "KlarnaUpdateSessionCmd",
                    url: "KlarnaUpdateSessionCmd",

                    successHandler: function (resKlarnaUpdate) {
                        console.log(resKlarnaUpdate);
                        try {
                            $('#loader_klarna').hide();
                            Klarna.Credit.load({
                                container: '#klarna-payments-container'
                            }, function (res) {
                                if (res["show_form"] == false) {
                                    if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                                        MessageHelper.displayErrorMessage("Beim Laden des Klarna Payment Widget ist ein Fehler aufgetreten.");
                                    } else{
                                        MessageHelper.displayErrorMessage("There was an error loading Klarna Payment Widget.");
                                    }
                                }
                            })
                        } catch (e) {
                            console.log(e);
                        }
                        $('.loader_klarna-container').width($('#klarna-credit-main').width());
                    },
                    failureHandler: function (resKlarnaUpdate) {
                        if (resKlarnaUpdate.errorMessage) {
                            MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessage);
                        } else {
                            if (resKlarnaUpdate.errorMessageKey) {
                                MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessageKey);
                            }
                        }
                    }
                });

                wcService.invoke("KlarnaUpdateSessionCmd", params);
        	}
        }
    });
}

function loadPaymentView(){
    requestSubmitted = true;

    goToPaymentStep();

    function removePaymentLoader(){
        $( "#loadingPaymentDiv" ).fadeOut(500, function() {
          // fadeOut complete. Remove the loading div
          $( "#loadingPaymentDiv" ).remove(); //makes page more lightweight 
          $('#loaderForview,.paymentDetails').css('height','auto');
      });  
    }

    var url = (isInToolkit ? "/webapp/wcs/stores/servlet" : "")+"/PaymentView?orderId="+$('#currentOrderId').val() +"&langId="+ WCParamJS.langId+"&catalogId=" +   WCParamJS.catalogId + "&storeId="+ WCParamJS.storeId + "&showRegTag=T" + ($("#PaymentError").val() != "" ? "&PaymentError="+$("#PaymentError").val() : "") + ($("#PayPalError").val() != "" ? "&PayPalError="+$("#PayPalError").val() : "");
    
    $.ajax({
        method: "GET",
        url: url,
        success: function(data, textStatus, jqXHR){
            removePaymentLoader();
            $('#loaderForview').html(data).promise().done(function(){
                var paymentDetailsTitle = $(".return-details-view-container .card-info--wrapper--title span");
                if (paymentDetailsTitle.length > 0) {
                    $(paymentDetailsTitle).html($("#paymentDetailsTitle").val());
                } else $(".return-details-page .payment-method").after('<div class="card-info--wrapper--title"><span>'+$("#paymentDetailsTitle").val()+'</span></div>');
                var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
                /*if(!sameaddressCheckbox.checked && klarnaEnabled == 'true'){ //hide klarna if billing and shipping address are different
                    $('.payment-method--text--input-Klarna').parent().hide();
                }*/
                if (affirmEnabled == 'true') {
                    affirm.ui.refresh();
                } else if (klarnaEnabled == 'true') {
                    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
                    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
                }
            });
            paymentsMethodSetup();
            submitRequest();    // Avoid Affirm error
            
            var Page_DeviceType = "";
            var isMobile = window.mobilecheck();
            
            if(isMobile){
            	Page_DeviceType = "Mobile";
            }else{
            	Page_DeviceType = "Desktop";
            }
            

            //HB-8540
            tealium_data2track.push({
                'id' : 'VirtualPage-View',
                'Page_Type': 'Static',
                'Page_Section1': 'Account',
                'Page_Section2': 'PaymentReturn',
                'Page_Brand' : brandCode,
                'Page_Country' :countryCode,
                'Page_Platform': "WCS",
                'User_EmailOptin' : tealiumUserEmailOptin,
                'User_Email_MD5' : localStorage.encryptedUserEmail,
                'Page_Language':storeLanguage.toUpperCase(),
                'Page_DeviceType' :Page_DeviceType,
                'User_LoginType' : "Standard",
                'User_LoginStatus': tealiumPageUserStatus,
                'Products': arrangeRoxProducts(tealiumProducts),
                'Order_Currency': currency,
                'Order_GiftCardCode': sessionStorage.Order_DiscountCode ? sessionStorage.Order_DiscountCode : '',
                'Order_DiscountName': sessionStorage.Order_DiscountName ? sessionStorage.Order_DiscountName : '',
                // 'Order_DiscountAmount':$checkoutObj.cartData.totalAdjustment ? $checkoutObj.cartData.totalAdjustment : tealiumOrder_DiscountAmount,
                'Order_ProductsAmount': tealiumOrder_ProductsAmount,
                'Order_ShippingAmount':utag_data.Order_ShippingAmount ? utag_data.Order_ShippingAmount  : '0' ,
                'Order_ShippingDiscount': utag_data.Order_ShippingDiscount ? utag_data.Order_ShippingDiscount : '0',
                'Order_ShippingTaxRate': utag_data.Order_ShippingTaxRate,
                'Order_TaxAmount' : tealiumOrder_TaxAmount ,
                'Order_ShippingMode': sessionStorage.shipmentMethod,
                'Order_State': sessionStorage.tealium_orderState ,
                'Order_ZipCode': sessionStorage.tealium_orderZipCode
            });
        }
    });
}

function setUpAccordion(){
    //shipping part
    $( " .shipping-step .accordion" ).click(function() {
        if($( " .shipping-step .accordion" ).siblings(".panel").hasClass('activated')){
            $(" .shipping-step .accordion" ).siblings(".panel").removeClass('activated');
        }else{
            $(" .shipping-step  .accordion" ).siblings(".panel").addClass('activated');
        }
      });
   //payment part 
   $( " .paymentDetails .accordion" ).click(function() {
        if($( " .paymentDetails .accordion" ).siblings(".panel").hasClass('activated')){

            $(" .paymentDetails .accordion" ).siblings(".panel").removeClass('activated');
        }else{
            $(" .paymentDetails .accordion" ).siblings(".panel").addClass('activated');
        }
      });

}

function printShippingBillingInformation(){
    var nickName =  "nickName";
    var lastName =  "lastName";
    var firstName =  "firstName";
    var middleName =  "middleName";
    var address1 =  "address1";
    var address2 =  "address2";
    var address3 =  "address3";
    var city =  "city";
    var state =  "state";
    var country =  "country";
    var zipCode =  "zipCode";
    var email1 =  "email1";
    var phone1 =  "phone1";
    var cpf =  "fax1";
    var neighborhood =  "fax2";
    var birth_date =  "birth_date";
    var birth_month =  "birth_month";
    var birth_year =  "birth_year";
    
    //START BOSS
    var isBoss = false;
    
    if($('div[shipmodecode="ShipToStore"]').length > 0){
    	if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
    		isBoss = true;
    	}    	
    }
    //END BOSS
    
    
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    var coutry_long = $(form1['country']).parent().find('.ui-selectmenu-text').text();
    form2Html = '';
    form1Html = '';
    
    form1Html +='<div class="shippingAddrress">';
    form1Html +='  <div class="info-wrapper">';
    form1Html +='    <div class="title"> ';
    form1Html +=        $("input[name=shippingText]").val();
    form1Html +=     '</div>';
    //if is boss we must show the name of selected store 
    //is isn't boss we show the user email, else if is a boss order we show the email of store
    //if is boss we don't show the name
    if(!isBoss){
    	form1Html +=    '<div class="email">'
        form1Html +=            form1[email1].value;
        form1Html +=     '</div>';
    	form1Html +=      '<div class="name">';
        form1Html +=        '<span>';
        form1Html +=            form1[firstName].value;
        form1Html +=         '  </span>';
        form1Html +=         '<span>';
        form1Html +=            form1[lastName].value;
        form1Html +=          '</span>';
        form1Html +=       '</div>';
    }else{
    	form1Html +=     '<div class="nameStore">';
    	form1Html +=     $('.selected-store-container .detail-row.store-name').text();
    	form1Html +=     '</div>';
    	form1Html +=    '<div class="email">'
        form1Html +=            $('.selected-store-container .detail-row.store-info a[href*="mail"]').text();
        form1Html +=     '</div>';
    }
    form1Html +=       '<div class="telephone">';
    form1Html +=            form1[phone1].value;
    form1Html +=       '</div>';
    form1Html +=       '<div class="address">';
    form1Html +=        '<span>';
    form1Html +=            form1[address1].value;
    form1Html +=         '  </span>';
    form1Html +=       '</div>';
    form1Html +=       '<div class="city">';
    form1Html +=        '<span>';
    form1Html +=            form1[city].value;
    form1Html +=         '  </span>';
    form1Html +=         '<span>';
    form1Html +=            form1[zipCode].value;
    form1Html +=          '</span>';
    form1Html +=         '<span>';
    form1Html +=            form1[state]?form1[state].value:'';
    form1Html +=          '   </span>';
    form1Html +=       '</div>';
    form1Html +=       '<div class="state">';
    form1Html +=            coutry_long;
    form1Html +=       '</div>';
    form1Html +=   '</div>';
    form1Html +='<div class="edit-button-mobile">';
    form1Html +=  $("input[name=editText]").val(); ;
    form1Html +='</div>';
    form1Html +='</div>';

    if(sameaddressCheckbox.checked || sameaddressCheckbox == null){
        form2 = form1
    }
        var coutry_long = $(form2['country']).parent().find('.ui-selectmenu-text').text();
        form2Html +='<div class="billingAddress">';
        form2Html +=' <div class="info-wrapper"> ';
        form2Html +='<div class="title"> ';
        form2Html +=        $("input[name=billingText]").val(); ;
        form2Html +=     '</div>';
        form2Html +=    '<div class="email">'
        form2Html +=            form2[email1].value;
        form2Html +=     '</div>';
        form2Html +=      '<div class="name">';
        form2Html +=        '<span>';
        form2Html +=            form2[firstName].value;
        form2Html +=         '  </span>';
        form2Html +=         '<span>';
        form2Html +=            form2[lastName].value;
        form2Html +=          '</span>';
        form2Html +=       '</div>';
        form2Html +=       '<div class="telephone">';
        form2Html +=            form2[phone1].value;
        form2Html +=       '</div>';
        form2Html +=       '<div class="address">';
        form2Html +=        '<span>';
        form2Html +=            form2[address1].value;
        form2Html +=         '  </span>';
        form2Html +=       '</div>';
        form2Html +=       '<div class="city">';
        form2Html +=        '<span>';
        form2Html +=            form2[city].value;
        form2Html +=         '  </span>';
        form2Html +=         '<span>';
        form2Html +=            form2[zipCode].value;
        form2Html +=          '</span>';
        form2Html +=         '<span>';
        form2Html +=            form2[state]?form2[state].value:'';
        form2Html +=          '   </span>';
        form2Html +=       '</div>';
        form2Html +=       '<div class="state">';
        form2Html +=            coutry_long;
        form2Html +=       '</div>';
        form2Html +='  </div>';
        form2Html +='  <div class="edit-button-mobile">';
        form2Html +=     $("input[name=editText]").val(); ;
        form2Html +='  </div>';
        form2Html +='  <div class="edit-button">';
        form2Html +=   $("input[name=editText]").val(); ;
        form2Html +='  </div>';
        form2Html +='</div>';
        form2Html +='  </div>';

        labelHtml = '';

        labelHtml +='<div class="shipping-info-wrapper">';
        labelHtml +='<div class="labelOptions">';
        labelHtml +=' <div class="info-wrapper"> ';
        labelHtml +='<div class="title"> ';
        labelHtml +=        $("input[name=labelText]").val(); ;
        labelHtml +=     '</div>';
        labelHtml +='     <div class="content"> ';
        labelHtml +=        $("#selectedLabelValue").val(); ;
        labelHtml +=     '</div>';
        labelHtml +='  </div>';
        labelHtml +='  <div class="edit-button">';
        labelHtml +=   $("input[name=editText]").val(); ;
        labelHtml +='  </div>';
        labelHtml +='  <div class="edit-button-mobile">';
        labelHtml +=     $("input[name=editText]").val(); ;
        labelHtml +='  </div>';
        labelHtml +='</div>';
    
        returnDetailsTitle = '';

        returnDetailsTitle += " <div class='return-details-title title-accordion accordion'>";
        returnDetailsTitle += "<div class='number'> 1</div>";
        returnDetailsTitle += "<h1 class='checkout-title myaccount_header' id='WC_UnregisteredCheckout_div_5' data-toggle='collapse'>";
        returnDetailsTitle += $("input[name=returnDetailsText]").val();
        returnDetailsTitle += "</h1>";
        returnDetailsTitle += "</div>";


    $('#shippingInformation').html(returnDetailsTitle + labelHtml + form1Html + form2Html);
    
    //if is boss we change the title in payment page
    if(isBoss){
    	$('.shipping-step .checkout-title.myaccount_header ').text($('#boss-typ').attr('value'));
    }
    
    $('#shippingInformation .edit-button,#shippingInformation .edit-button-mobile').on('click',function(){
        if(isBoss){
        	$('.shipping-step .checkout-title.myaccount_header ').text($('#shippingBillingMessage').attr('value'));
        }
    	returnInShippingForm();
    });

}

function selectReturnLabel(){
    var selectedLabel = "";
    $("#label-options input").on("click", function(){
        $(this).each(function(){
            if ($(this).is(":checked")) {
                $(".shipping-info-type").removeClass("selected");
                $(".single-shipping-method-wrapper").removeClass("selected");
                $(this).closest(".single-shipping-method-wrapper").find(".shipping-info-type").addClass("selected");
                $(this).closest(".single-shipping-method-wrapper").addClass("selected");
                selectedLabel = $(".single-shipping-method-wrapper.selected").attr("shippinglabeltype");
                updateItemsReturn(selectedLabel);
            }
        });
    });
}

function chooseBillingAddress(){
    $(".add_new_address").on("click",function(){
        $('#billingAddressCreateEditFormDiv_1 .input-style input').val("");
        $("#billingAddressCreateEditFormDiv_1").show();
        if (!$(this).find('input').prop("checked")){
            $(this).find('input').attr('checked', true);
            $('.address_container input').not($(this).find('input')).attr('checked', false);
            $(".myaccount_address").removeClass("selected");
            $(this).addClass("selected");
        }
    });

    $(".myaccount_address").on("click", function () {
        copyAddressIntoBillingForm('myAccountAddressFormDiv','billingAddressCreateEditFormDiv_1');
        $(".add_new_address").removeClass("selected");
        $(this).addClass("selected");
        var selectedAddress = $(this).find("input");
        selectedAddress.attr("checked", true);
        $('.address_container input').not(selectedAddress).attr('checked', false);
        $("#billingAddressCreateEditFormDiv_1").hide();
     });

     if ($('.myaccount_address input').prop('checked') == true) 
        $(".add_new_address").removeClass("selected");
        $(".myaccount_address").addClass("selected");{
        copyAddressIntoBillingForm('myAccountAddressFormDiv','billingAddressCreateEditFormDiv_1');
        $('.myaccount_address .text').html($("#myAccountSavedAddress").val());
     }
}

function sameShippingAndBillingAddressReturn() {
    var userType = $("#userType").val();
    $("#SameShippingAndBillingAddress").on("click", function(event){
        // event.preventDefault();
        if ($(this).prop("checked") == true){
            //use same shipping and billing address
            $(".return-details-page .unregistered-form .address_form").hide();
            if (userType == 'R'){
                $('#billingCreateEditArea1 .address_container').hide(); 
                $('.address_container .add_new_address input').attr('checked', false);
                $('.address_container .myaccount_address input').attr('checked', false);
            }
        } else {
            if (userType == 'G'){
                $(".return-details-page .unregistered-form .address_form").show();
                $('#billingAddressCreateEditFormDiv_1 .input-style input').val("");
            } else if (userType == 'R'){
                $('#billingCreateEditArea1 .address_container').show(); 
                $("#billingAddressCreateEditFormDiv_1").hide();
                $('.address_container .myaccount_address input').attr('checked', true); //When same address option is unchecked, set myAccount address as default
                chooseBillingAddress();
            }
        }
    });
}

function copyAddressIntoBillingForm (fromName, toName){
    var form = document.forms[fromName];
    var to = document.forms[toName];

    to.nickName.value = form.nickName.value;
    to.firstName.value = form.firstName.value;
    to.lastName.value = form.lastName.value;
    to.address1.value = form.address1.value;
    to.address2.value = form.address2.value;
    to.city.value = form.city.value;
    if(isIE){
        (document.getElementById("stateDiv2").firstChild).value = (document.getElementById("stateDiv1").firstChild).value;
    } else if (to.state !== undefined) {
        to.state.value = form.state.value;
    }
    to.zipCode.value = form.zipCode.value;
    to.country.value = form.country.value;
    if (to.phone1 !== undefined) {
        to.phone1.value = form.phone1.value;
    }
    if (to.email1 !== undefined) {
        to.email1.value = form.email1.value;
    }
    if(form.middleName) {
        to.middleName.value = form.middleName.value;
    }
}

function saveLabel(labelURL) {
    var link = document.createElement('a');
    if($('#pdfReturn').length == 0){
    	link.href = labelURL;
        link.target = '_blank';
        link.download = 'ShippingLabel.gif';
        document.body.appendChild(link);
    }else{
    	link.setAttribute("download", "ShippingLabel.pdf");
    	link.setAttribute("href", labelURL);
    }
    
    link.click();
}

/* ------------------------------------------ DOCUMENT READY ------------------------------------------ */

$(document).ready(function() {
    var page = $('[id^="pageInfo"]').val();

   if(page == 'TrackMyOrder'){
        replaceImageCheckout($('.checkout-image-product'));
        initVariables();
        placeDeliveryDate();
        postOperations();
        perksInitialization();
   }else if (page == "createReturn"){
        replaceImageCheckout($('.checkout-image-product'));
        initVariables();
        placeDeliveryDate();
        postOperations();
        perksInitialization();

        if (!(window.mobilecheck() || window.tabletPortraitCheck())){
            $(".return-checkbox-container .reasons-dropdown").css("width", "calc(100% - " + $(".return-checkbox-container .checkbox").width() + "px)");
        }

        manageReasonsDropdown();
        $(".return-checkbox-container .checkbox input").on("click", function(){
            if ($(this).prop("checked") == true){
                $(this).parent().addClass("checked");
                $(".shopping-bag-page__right .cta-container .proceed").addClass("show");
            } else {
                $(this).parent().removeClass("checked");
                $(".shopping-bag-page__right .cta-container .proceed").removeClass("show");
            }

            showProceedToReturnButton();
        });

        $(document).off("click", ".shopping-bag-page__right .cta-container .proceed").on("click", ".shopping-bag-page__right .cta-container .proceed", function(){
            createCheckedItemsParamsUrl();
        });

    } else if(page == 'Shipping'){
        //if there are two or more shipping method to choose, show them
        if ($(".shipping-container .shipping_method_content .row_main_shipping").length > 1) {
                $(".shipping-container .choose_shipping_method").show();
            }
        //call cartservice fot total
        $checkoutObj.getCartData(function() {
            renderOrderSummary();
            replaceImageCheckout($('.items_in_cart_summary .product_image picture'));
        });
   
        if (window.location.href.indexOf('AffirmForwardCmd') > -1
                || window.location.href.indexOf('KlarnaForwardCmd') > -1) {
            loadPaymentView();
        }
        if($('#prescriptionIsPresent').val()){
       
            $('#prescription-message').show();
            $('#prescription-message').addClass('prescription_showed');
        }

        if(isPersol && !window.mobilecheck() && ($('.persolDesktop input').is(":checked") || $('.persolMobile input').is(":checked"))) {
            $('.persolDesktop input').click();
        }

        
    } else if (page == 'returnDetails'){
        replaceImageCheckout($('.checkout-image-product'));
        $(".single-shipping-method-wrapper").eq(0).find("input").prop("checked", true);
        selectReturnLabel();
        sameShippingAndBillingAddressReturn();
        $checkoutObj.getCartData(function() {
            renderOrderSummary();
        });

        if (window.location.href.indexOf('AffirmForwardCmd') > -1 || window.location.href.indexOf('KlarnaForwardCmd') > -1) {
            loadPaymentView();
        }

        $(document).off("click", ".return-details-page .edit-text, #back_link").on("click", ".return-details-page .edit-text,#back_link", function(){
            cancelRma();
        });

        $("#confirmReturnNoCheckout").on("click", function(){
            addCheckoutLoader();
            processRma();
        });
    } else if (page == 'returnThankYou'){
        replaceImageCheckout($('.items_in_cart_summary .product_image picture'));
        perksInitialization();
        renderOrderSummary();
        sessionStorage.setItem('rmaCreated',true);
    }

    if (window.mobilecheck() || window.tabletPortraitCheck()){
        showHideOrderDetails();
    }

});

jQuery(document).ready(function($) {
    var page = $('[id^="pageInfo"]').val();
    /* HB-9660 manage back button */
    var rmaCreated = sessionStorage.getItem('rmaCreated');
    if (window.history && window.history.pushState) {
      if(performance.navigation.type == 2 && !rmaCreated ){
          cancelRma();
      }
      if (performance.navigation.type == 2 && page == 'returnDetails'){
    	  window.location.href = $('#back_link').attr('href');
      }
    }
  });

/* ------------------------------------------ DOCUMENT READY ------------------------------------------ */
